import { render, staticRenderFns } from "./CmsSopContent.vue?vue&type=template&id=5156a263&scoped=true&"
import script from "./CmsSopContent.vue?vue&type=script&lang=js&"
export * from "./CmsSopContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5156a263",
  null
  
)

export default component.exports